module.exports = __webpack_public_path__ + "img/1.8ef873e4.jpg";